import React from 'react';
import { pdf } from '@react-pdf/renderer';
import FileOpeningPdf from './FileOpeningPdf';
import FixedFeePdf from './FixedFeePdf';
import toast from 'react-hot-toast';
import ClientCareGeneralPdf from './ClientCareGeneralPdf';

const downloadPdf = async (data) => {
  try {
    const blob = await pdf(<FileOpeningPdf data={data} />).toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `fileOpening-${data.id || 'new'}-${new Date().toISOString().split('T')[0]}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error generating PDF:', error);
    toast.error('Failed to generate PDF');
  }
  try {
    const blob = await pdf(<FixedFeePdf data={data} />).toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `FixedFee-${data.id || 'new'}-${new Date().toISOString().split('T')[0]}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error generating Fee PDF:', error);
    toast.error('Failed to generate Fee PDF');
  }
  try {
    const blob = await pdf(<ClientCareGeneralPdf data={data} />).toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `ClientCare-${data.id || 'new'}-${new Date().toISOString().split('T')[0]}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error generating Client Care PDF:', error);
    toast.error('Failed to generate Client Care PDF');
  }
};

const FileOpeningAllPdfButton = ({ data }) => {
  return (
    <>
      <button
        onClick={() => downloadPdf(data)}
        className="bg-green-600 mr-4 hover:bg-green-700 text-white font-semibold px-4 py-2 rounded-md shadow ml-4">
        Download All PDFs
      </button>
    </>
  );
};

export default FileOpeningAllPdfButton;
